import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useHashScroll(ready = true) {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash || !ready) return;
    const id = hash.slice(1);
    const scroll = () => {
      const el = document.getElementById(id);
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY - 100;
      if (window.__lenis) window.__lenis.scrollTo(top, { duration: 1.2 });
      else window.scrollTo({ top, behavior: "smooth" });
    };
    const t = setTimeout(scroll, 300);
    return () => clearTimeout(t);
  }, [hash, ready]);
}
